<fieldset class="consent-list">
  <legend class="sr-only">Agreements</legend>

  @for (consent of ordered(); track consent.presentationToken; let i = $index) {
    <div class="consent">
      @if (consent.notice?.text) {
        <p class="consent-notice" [id]="noticeId(i)">{{ consent.notice?.text }}</p>
      }

      <div class="consent-row">
        <input
          class="consent-checkbox"
          type="checkbox"
          [id]="inputId(i)"
          [checked]="isTicked(consent)"
          [required]="isRequired(consent)"
          [attr.aria-required]="isRequired(consent)"
          [attr.aria-describedby]="consent.notice?.text ? noticeId(i) : null"
          (change)="toggle(consent, $any($event.target).checked)"
        />
        <label class="consent-label" [for]="inputId(i)">
          <span class="consent-checkbox-text">{{ consent.checkboxText.text }}</span>
          @if (!isRequired(consent)) {
            <span class="consent-optional">(optional)</span>
          }
        </label>
      </div>

      @if (consent.documents?.length || (consent.notice?.url && !consent.notice?.text)) {
        <ul class="consent-documents">
          @if (consent.notice?.url && !consent.notice?.text) {
            <li>
              <a class="link consent-document" rel="noopener" target="_blank" [href]="consent.notice?.url">
                {{ consent.notice?.title || consent.notice?.documentId }}<span class="sr-only"> (opens in a new tab)</span>
              </a>
            </li>
          }
          @for (document of consent.documents ?? []; track document.documentId) {
            <li>
              <a class="link consent-document" rel="noopener" target="_blank" [href]="document.url">
                {{ document.title || document.documentId }}<span class="sr-only"> (opens in a new tab)</span>
              </a>
            </li>
          }
        </ul>
      }
    </div>
  }
</fieldset>
